module.exports = __webpack_public_path__ + "324629c85ce91c26dffdc4a087835954.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/01GoldenCityHafenbar.jpg
// module id = 469
// module chunks = 0